import 'regenerator-runtime/runtime';
import { cleanS3Url, TextBackground } from '@bynder-studio/misc';
import { BoundedText } from '../Core/BoundedText';
import type { TextProps } from '../Core/StructuredText';
import { TextController } from '../Core/TextController';
import { convertLeadingValue } from './utils';
import { Direction, Placement } from '../Core/Types';

export type TextConfig = {
    text: TextProps;
    placement: Placement;
    boxWidth: number;
    boxHeight: number;
    xAlign: string;
    yAlign: string;
    fontSize: number;
    tracking: number;
    leading: number;
    minFontScale: number;
    textBackground: TextBackground;
    textDirection: Direction;
};

export type Glyph = any;

// export type StructuredTextLayout = {
//     lines: {
//         glyphs: Glyph[];
//     }[];
// };

// export type BoundedText = {
//     // getData(): StructuredTextLayout;
//     // getConfig(): TextConfig;
//     getData(): any;
//     getConfig(): any;
//     updateConfig(config: Partial<TextConfig>): void;
// };

export class TextRenderer {
    private static instance: TextRenderer;

    private textController: TextController;

    private defaultFontBlob: ArrayBuffer | undefined;

    private loadedFonts = new Map<string, string | undefined>();

    static async init(hbWasmFile: Buffer) {
        if (TextRenderer.instance) {
            return TextRenderer.instance;
        }

        const textRenderer = new TextRenderer();
        textRenderer.textController = await TextController.init(() => hbWasmFile);
        TextRenderer.instance = textRenderer;

        return TextRenderer.instance;
    }

    static getInstance() {
        if (!TextRenderer.instance) {
            throw new Error('Need to initialization asynchronously');
        }

        return TextRenderer.instance;
    }

    setDefaultFont(defaultFontBlob: ArrayBuffer) {
        this.defaultFontBlob = defaultFontBlob;
        this.setFont('default', defaultFontBlob);

        return this;
    }

    getDefaultFont(): ArrayBuffer {
        return this.defaultFontBlob!;
    }

    setFont(fontId: string, fontBlob: ArrayBuffer, src?: string) {
        const sourceKey = src === undefined ? undefined : cleanS3Url(src);

        if (!this.loadedFonts.has(fontId)) {
            this.loadedFonts.set(fontId, sourceKey);
            this.textController.addExternallyLoadedFonts(new Map([[fontId, fontBlob]]));

            return;
        }

        if (sourceKey === undefined || sourceKey === this.loadedFonts.get(fontId)) {
            return;
        }

        this.loadedFonts.set(fontId, sourceKey);
        this.textController.replaceFont(fontId, fontBlob);
    }

    createBoundedText(textStruct: TextProps, config: any): BoundedText {
        return this.textController.createBoundedText(textStruct, config);
    }

    convertLeadingValue(fontId: string, fontLeading: number) {
        const _fontId = this.loadedFonts.has(fontId) ? fontId : 'default';

        return convertLeadingValue(this.textController, _fontId, fontLeading);
    }

    getFontData(fontId: string) {
        const _fontId = this.loadedFonts.has(fontId) ? fontId : 'default';

        return this.textController.getFontData(_fontId);
    }
}
